import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MemberPickerComponent } from './member-picker.component';

// Its own module (rather than declared in SharedModule) so pages that SharedModule itself imports - like the
// time and billing create page - can use the picker without a circular import.
@NgModule({
  declarations: [MemberPickerComponent],
  imports: [CommonModule, FormsModule],
  exports: [MemberPickerComponent]
})
export class MemberPickerModule { }
